/* eslint no-prototype-builtins: "off" */

'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../core/translator');
const Container = require('./../../../core/container');

const PopinManager = require('./../../../services/popin');
const Zone = require('./../../../services/structure/zone');
const Repository = require('./../repository/TagRepository');
const Notifier = require('./../../../services/notifier');
const Formbuilder = require('./../../../services/form');
const LangRepository = require('./../../user/repository/LangRepository');

const Tpl = require('./../template/settings.hbs');
const ItemLevelTpl = require('./../template/item_level.hbs');

module.exports.onMenuClick = function() {
  let $tpl = jQuery(Tpl());
  let $searchInput = $tpl.find('.input-search');
  let $tagList = $tpl.find('.tag-list');

  const getParent = (item) => {
    return new Promise((resolve) => {
      if (item && item['parent_uid']) {
        Repository.find(item['parent_uid']).done((parent) => {
          resolve(parent);
        });
      } else {
        resolve(null);
      }
    });
  };

  const onTagForm = (tag = {}) => {
    let isNew = !tag.uid;
    let $container = jQuery('<div />');
    let form;

    let popin = PopinManager.createPopin({
      'title': Translator.translate(isNew ? 'tag_create_modal_title' : 'tag_edit_modal_title'),
      'height': 700,
      'width': 500,
      'position': {my: 'center top', at: 'center top+50', of: window},
      'buttons': [
        {
          class: 'popin popin-cancel',
          text: Translator.translate('discard'),
          click: function() {
            popin.hide();
          },
        },
        {
          text: Translator.translate(isNew ? 'tag_creation_title' : 'submit'),
          click: function() {
            form.submit();
          },
        },
      ],
    });

    LangRepository.findAll('tag').done((langs) => {
      getParent(tag).then((parent) => {
        let dataLangs = tag.translations || {};
        let formConfig = {
          elements: {
            label: {
              label: Translator.translate('tag_title'),
              type: 'text',
              value: tag.keyword || '',
              group: {
                id: 'main',
              },
            },
            parent: {
              label: Translator.translate('tag_choose_parent'),
              type: 'selectTag',
              value: parent ? parent.uid : null,
              oneValue: true,
              showChildren: false,
              context: 'get_parent',
              group: {
                id: 'main',
              },
            },
          },
          form: {
            'submit_class': 'd-none',
            'form_class': 'mb-0',
          },
        };

        let langGroupTitle = null;
        langs.forEach((lang) => {
          if (lang['is_active']) {
            formConfig.elements[`lang_${lang.id}`] = {
              label: lang.label,
              type: 'text',
              value: dataLangs[lang.id],
              group: {
                id: 'lang',
              },
            };

            if (!langGroupTitle) {
              langGroupTitle = Translator.translate('translation');

              formConfig.elements[`lang_${lang.id}`].group.title = langGroupTitle;
            }
          }
        });

        form = Formbuilder.getForm(formConfig);

        form.on('submit', function(data) {
          let val = jQuery.trim(data.label.replace(/[\/\\"]/gi, ' ')).replace(/\s+/g, ' ');
          let translations = {};

          for (let key in data) {
            if (data.hasOwnProperty(key)) {
              if (key.includes('lang_')) {
                let langId = key.replace('lang_', '');

                translations[langId] = data[key];
              }
            }
          }

          if (val) {
            if (isNew) {
              create(val, data.parent, translations).then(() => {
                popin.hide();
                list(true).then(() => {
                  Notifier.success(Translator.translate('tag_created'));
                });
              }).catch(() => {
                form.addError('label', Translator.translate('tag_already_exist'));
                form.displayErrors();
              });
            } else {
              Repository.update({
                'uid': tag.uid,
                'parent_uid': data.parent,
                'name': val,
                translations,
              }).done(() => {
                popin.hide();
                list();
                Notifier.success(Translator.translate('tag_edited'));
              });
            }
          }
        });

        $container.append(form.render());
      });
    });

    Container.set('prevent-hide-toolbar', true);
    Container.set('prevent-hide-overlay', true);
    popin.on('close', function() {
      setTimeout(function() {
        Container.set('prevent-hide-toolbar', false);
        Container.set('prevent-hide-overlay', false);
      }, 100);
    });

    popin.setContent($container);

    popin.display();
  };

  const onDeleteTag = function(tag) {
    let popin = PopinManager.createPopin({
      'title': Translator.translate('tag_delete_modal_title'),
      'minHeight': 50,
      'buttons': [
        {
          class: 'popin popin-cancel',
          text: Translator.translate('discard'),
          click: function() {
            popin.hide();
          },
        },
        {
          text: Translator.translate('delete'),
          click: function() {
            popin.hide();
            Repository.delete(tag.uid).done(function() {
              list();
              Notifier.success(Translator.translate('tag_deleted'));
            });
          },
        },
      ],
    });

    Container.set('prevent-hide-toolbar', true);
    Container.set('prevent-hide-overlay', true);
    popin.on('close', function() {
      setTimeout(function() {
        Container.set('prevent-hide-toolbar', false);
        Container.set('prevent-hide-overlay', false);
      }, 100);
    });

    Repository.findLinkedPages(tag.uid).done(function(pages) {
      let content = Translator.translate(pages.length ? 'tag_delete_linked_page_confirm' : 'tag_delete_confirm', {tag: tag.keyword});

      popin.setContent(`<p>${content}</p>`);
      popin.display();
    });
  };

  const list = () => {
    $tagList.html('');
    return new Promise((resolve, reject) => {
      Repository.findFirstLevel().done((tags) => {
        buildItems(tags, 1, $tagList);
      });

      resolve();
    });
  };

  const search = (term) => {
    Repository.findBy({term}).done((tags) => {
      $tagList.html('');
      tags.forEach((tag) => {
        tag['has_children'] = false;
        buildItem(tag, 1, $tagList);
      });
    });
  };

  const buildItems = (tags, level, $container) => {
    tags.forEach((tag) => {
      buildItem(tag, level, $container);
    });
  };

  const buildItem = (tag, level, $container) => {
    let {uid, keyword} = tag;
    let $item = jQuery(ItemLevelTpl({uid, keyword, level}));
    let $title = $item.children(`h${level}`);

    if (level === 3) {
      $title.prepend('<i class="icon icon-angle-right mr-2"></i>');
    }

    $title.find('.more-options').find('button.edit').on('click', function() {
      onTagForm(tag);
    });

    $title.find('.more-options').find('button.delete').on('click', function() {
      onDeleteTag(tag);
    });

    $title.find('button.btn-more').on('click', () => {
      $title.find('.more-options').toggleClass('show');
    });

    if (tag['has_children']) {
      $item.addClass('has-children');

      Repository.findByParent(tag.uid).done((tags) => {
        buildItems(tags, level + 1, $item.find('.item-level-wrapper'));
      });
    }

    $container.append($item);
  };

  const create = (name, parentUid, translations) => {
    return new Promise((resolve, reject) => {
      Repository.create({name, 'parent_uid': parentUid, translations}).done((item) => {
        resolve(item);
      }).fail(reject);
    });
  };

  $tpl.find('.create-tag').on('click', onTagForm);

  $searchInput.on('keyup', function() {
    let term = jQuery.trim($searchInput.val().replace(/[\/\\"]/gi, ' ')).replace(/\s+/g, ' ');

    if (!term) {
      list();
    } else {
      search(term);
    }
  });

  list();

  jQuery('body').on('click', function(e) {
    if (!jQuery(e.target).parent().hasClass('btn-more')) {
      $tpl.find('.more-options').removeClass('show');
    }
  });

  Zone.addLayer(Translator.translate('tag_management'), `<p>${Translator.translate('tag_management_description')}</p>`);
  Zone.setFullPanel(Translator.translate('tag_management'), $tpl);
};
